module.exports = __webpack_public_path__ + "img/t4-8.8f4b6254.png";